/* Mead Recipe Builder v11 — Craft a Brew */
/* Calc engine, cart integration, fermentation timeline */

/* ============================================================
   MEAD RECIPE BUILDER v2 — calculation engine + UI logic
   Vanilla JS, mirrors recipe-builder.js patterns
   ============================================================ */

// --- Embedded glass image (base64) so HTML is fully self-contained ---


// ===== HONEY DATABASE =====
// PPG (points per pound per gallon) varies slightly by water content
// All sourced from USDA + standard mead-making references
var HONEYS = [
  // CAB-stocked honey (priority placement)
  // Each entry has a `pouches` array listing the physical SKUs available.
  // The 40 oz pouch (2.5 lb) is the primary mead-making size; the 12 oz bottle
  // (0.75 lb) is the small backsweetening size. renderCart picks the cheapest
  // combination via findOptimalPouchCombo(). `price`/`handle` mirror the 40 oz
  // for any legacy code that might read them.
  { id: "cab_orange", name: "Orange Blossom Honey", brand: "Craft a Brew", ppg: 35, price: 22.99, handle: "orange-blossom-honey-for-mead", flavor: "citrus, white flowers", cab: true,
    pouches: [
      { size: 2.5,  price: 22.99, handle: "orange-blossom-honey-for-mead", label: "40 oz" },
      { size: 0.75, price: 9.99,  handle: "orange-blossom-honey-for-backsweetening-mead", label: "12 oz" }
    ]
  },
  { id: "cab_wildflower", name: "Wildflower Honey", brand: "Craft a Brew", ppg: 35, price: 22.99, handle: "honey-for-mead", flavor: "complex, varies by season", cab: true,
    pouches: [
      { size: 2.5,  price: 22.99, handle: "honey-for-mead", label: "40 oz" },
      { size: 0.75, price: 8.99,  handle: "wildflower-honey-for-mead-12-oz", label: "12 oz" }
    ]
  },
  { id: "cab_hawaiian", name: "Hawaiian Wildflower Honey", brand: "Craft a Brew", ppg: 35, price: 27.99, handle: "hawaiian-wildflower-honey-for-mead", flavor: "tropical, lehua, delicate floral", cab: true,
    pouches: [
      { size: 2.5,  price: 27.99, handle: "hawaiian-wildflower-honey-for-mead", label: "40 oz" },
      { size: 0.75, price: 10.99, handle: "hawaiian-wildflower-honey-for-mead-12-oz", label: "12 oz" }
    ]
  },
  { id: "cab_hawaiian_mango", name: "Hawaiian Mango Blossom Honey", brand: "Craft a Brew", ppg: 35, price: 27.99, handle: "mango-blossom-honey-for-mead", flavor: "tropical, mango, fruity floral", cab: true,
    pouches: [
      { size: 2.5,  price: 27.99, handle: "mango-blossom-honey-for-mead", label: "40 oz" }
      // No 12 oz bottle available for Hawaiian Mango Blossom
    ]
  },
  // Other varieties (no CAB SKU yet — would need to source or mark as customer-supplied)
  { id: "clover", name: "Clover Honey", brand: "Generic", ppg: 35, price: 12.99, handle: null, flavor: "mild, sweet, classic" },
  { id: "buckwheat", name: "Buckwheat Honey", brand: "Generic", ppg: 34, price: 16.99, handle: null, flavor: "bold, earthy, molasses" },
  { id: "tupelo", name: "Tupelo Honey", brand: "Generic", ppg: 36, price: 24.99, handle: null, flavor: "delicate, buttery, never crystallizes" },
  { id: "acacia", name: "Acacia Honey", brand: "Generic", ppg: 36, price: 18.99, handle: null, flavor: "very mild, light floral" },
  { id: "sourwood", name: "Sourwood Honey", brand: "Generic", ppg: 35, price: 22.99, handle: null, flavor: "buttery, anise, prized in southeast US" },
  { id: "sage", name: "Sage Honey", brand: "Generic", ppg: 35, price: 19.99, handle: null, flavor: "light, slow to crystallize, herbal" },
  { id: "manuka", name: "Manuka Honey", brand: "Generic", ppg: 33, price: 39.99, handle: null, flavor: "earthy, medicinal, distinctive" },
  { id: "honeydew", name: "Honeydew Honey", brand: "Generic", ppg: 34, price: 17.99, handle: null, flavor: "dark, malty, less sweet" },
  { id: "mesquite", name: "Mesquite Honey", brand: "Generic", ppg: 35, price: 18.99, handle: null, flavor: "smoky, rich, southwest desert" },
  { id: "avocado", name: "Avocado Honey", brand: "Generic", ppg: 35, price: 19.99, handle: null, flavor: "buttery, dark, rich" },
  { id: "lavender", name: "Lavender Honey", brand: "Generic", ppg: 35, price: 21.99, handle: null, flavor: "floral, subtle, French Provence classic" },
  { id: "blueberry", name: "Blueberry Blossom Honey", brand: "Generic", ppg: 35, price: 19.99, handle: null, flavor: "fruity, tangy, buttery finish" }
];

// ===== FRUIT DATABASE (USDA) =====
// sugar = % of weight that's fermentable sugar; water = % water by weight
var FRUITS = [
  { id: "strawberry", name: "Strawberry", sugar: 5.45, water: 91.0, unit: "lb", price: 0, handle: null },
  { id: "raspberry", name: "Raspberry", sugar: 4.98, water: 85.8, unit: "lb", price: 0, handle: null },
  { id: "blackberry", name: "Blackberry", sugar: 7.86, water: 82.5, unit: "lb", price: 0, handle: null },
  { id: "blueberry", name: "Blueberry", sugar: 9.36, water: 84.2, unit: "lb", price: 0, handle: null },
  { id: "apple", name: "Apple (fresh, diced)", sugar: 10.39, water: 85.6, unit: "lb", price: 0, handle: null },
  { id: "cherry_sweet", name: "Cherry, Sweet", sugar: 13.63, water: 82.2, unit: "lb", price: 0, handle: null },
  { id: "cherry_tart", name: "Cherry, Tart", sugar: 8.20, water: 86.1, unit: "lb", price: 0, handle: null },
  { id: "peach", name: "Peach", sugar: 8.53, water: 88.3, unit: "lb", price: 0, handle: null },
  { id: "apricot", name: "Apricot", sugar: 9.17, water: 84.6, unit: "lb", price: 0, handle: null },
  { id: "plum", name: "Plum", sugar: 9.86, water: 87.2, unit: "lb", price: 0, handle: null },
  { id: "mango", name: "Mango", sugar: 12.55, water: 83.5, unit: "lb", price: 0, handle: null },
  { id: "pineapple", name: "Pineapple", sugar: 10.39, water: 86.0, unit: "lb", price: 0, handle: null },
  { id: "elderberry", name: "Elderberry", sugar: 6.11, water: 79.8, unit: "lb", price: 0, handle: null },
  { id: "cranberry", name: "Cranberry", sugar: 8.44, water: 87.3, unit: "lb", price: 0, handle: null },
  { id: "pomegranate", name: "Pomegranate", sugar: 12.60, water: 77.9, unit: "lb", price: 0, handle: null },
  { id: "fig", name: "Fig (fresh)", sugar: 14.05, water: 79.1, unit: "lb", price: 0, handle: null },
  { id: "currant_black", name: "Black Currant", sugar: 9.30, water: 82.0, unit: "lb", price: 0, handle: null },
  { id: "grape_concord", name: "Concord Grapes", sugar: 8.89, water: 83.0, unit: "lb", price: 0, handle: null },
  // Juices (treated as 100% fermentable, denser sugar)
  { id: "raw_cider", name: "Raw Apple Cider (unfiltered)", sugar: 12.50, water: 86.5, unit: "qt", lbPerQt: 2.2, price: 0, handle: null, isJuice: true },
  { id: "apple_juice", name: "Apple Juice (filtered/pasteurized)", sugar: 10.30, water: 89.7, unit: "qt", lbPerQt: 2.2, price: 0, handle: null, isJuice: true },
  { id: "grape_juice_white", name: "White Grape Juice", sugar: 15.80, water: 83.7, unit: "qt", lbPerQt: 2.2, price: 0, handle: null, isJuice: true },
  { id: "grape_juice_purple", name: "Purple Grape Juice", sugar: 15.60, water: 83.7, unit: "qt", lbPerQt: 2.2, price: 0, handle: null, isJuice: true },
  { id: "cranberry_juice", name: "Cranberry Juice", sugar: 7.26, water: 92.3, unit: "qt", lbPerQt: 2.2, price: 0, handle: null, isJuice: true },
  { id: "orange_juice", name: "Orange Juice", sugar: 9.39, water: 88.5, unit: "qt", lbPerQt: 2.2, price: 0, handle: null, isJuice: true },
  // Dried (concentrated)
  { id: "raisin", name: "Raisins", sugar: 68.35, water: 16.6, unit: "lb", price: 0, handle: null },
  { id: "date", name: "Dates (dried)", sugar: 64.7, water: 20.9, unit: "lb", price: 0, handle: null }
];

// ===== SPICE DATABASE =====
var SPICES = [
  { id: "cinnamon_stick", name: "Cinnamon Stick", unit: "stick", note: "Add in secondary, 7-14 days", price: 2.99, handle: null },
  { id: "vanilla_bean", name: "Vanilla Bean (whole)", unit: "bean", note: "Split & scrape, secondary, 14 days", price: 6.99, handle: null },
  { id: "cardamom", name: "Cardamom Pod", unit: "pod", note: "Crush gently, secondary 5-10 days", price: 1.99, handle: null },
  { id: "clove", name: "Whole Clove", unit: "pc", note: "Use sparingly — very strong", price: 0.99, handle: null },
  { id: "ginger_fresh", name: "Fresh Ginger Root", unit: "oz", note: "Sliced, secondary 3-7 days", price: 1.99, handle: null },
  { id: "juniper", name: "Juniper Berry", unit: "tsp", note: "Crushed, primary or secondary", price: 1.49, handle: null },
  { id: "orange_peel", name: "Orange Peel (dried)", unit: "tsp", note: "Avoid pith, secondary 5-7 days", price: 1.99, handle: null },
  { id: "lemon_peel", name: "Lemon Peel (dried)", unit: "tsp", note: "Avoid pith, secondary 5-7 days", price: 1.99, handle: null },
  { id: "rose_hip", name: "Rose Hip", unit: "tsp", note: "Adds vitamin C and acidity", price: 2.49, handle: null },
  { id: "hibiscus", name: "Hibiscus Flower (dried)", unit: "oz", note: "Adds tartness and red color", price: 3.99, handle: null },
  { id: "lavender", name: "Lavender (culinary)", unit: "tsp", note: "Use sparingly — soapy if overdone", price: 2.99, handle: null },
  { id: "peppercorn_pink", name: "Pink Peppercorn", unit: "tsp", note: "Mild peppery floral note", price: 2.49, handle: null },
  { id: "star_anise", name: "Star Anise", unit: "pc", note: "Strong licorice — 1-2 max", price: 0.99, handle: null },
  { id: "bay_leaf", name: "Bay Leaf", unit: "leaf", note: "Subtle herbal note", price: 0.49, handle: null },
  { id: "cacao_nib", name: "Cacao Nib", unit: "oz", note: "Secondary 5-10 days, dark mead", price: 3.99, handle: null }
];

// ===== YEAST DATABASE =====
// abvMax = max ABV tolerance; cat = mead/wine/champagne/non-traditional
var YEASTS = [
  // === MEAD SPECIALISTS (Lalvin) — all stocked at Craft a Brew ===
  { id: "d47", name: "Lalvin ICV-D47", cat: "mead", abvMin: 0, abvMax: 14, tempMin: 50, tempMax: 86, optimal: 65, char: "Fruity, full body", note: "CAB Mead Kit yeast — smooth and round on the finish", price: 1.59, handle: "lalvin-d47-yeast", cab: true, yanDemand: 1.0, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "ec1118", name: "Lalvin EC-1118", cat: "mead", abvMin: 0, abvMax: 18, tempMin: 41, tempMax: 86, optimal: 65, char: "Neutral, very dry", note: "Champagne-style — finishes bone dry, very forgiving", price: 1.59, handle: "lalvin-ec1118-yeast", cab: true, yanDemand: 0.7, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "k1v1116", name: "Lalvin K1V-1116", cat: "mead", abvMin: 0, abvMax: 18, tempMin: 50, tempMax: 86, optimal: 65, char: "Fruit-friendly, dry", note: "Great for melomel — preserves fruit aroma", price: 1.59, handle: "lalvin-k1-v1116-yeast", cab: true, yanDemand: 1.0, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "71b1122", name: "Lalvin 71B-1122", cat: "mead", abvMin: 0, abvMax: 14, tempMin: 59, tempMax: 86, optimal: 68, char: "Smooth, fruity", note: "Metabolizes malic acid — softens sharp fruits like raspberry & cranberry", price: 1.59, handle: "lalvin-71b-yeast", cab: true, yanDemand: 1.0, packetWeight: "5g", cellsB: 6, form: "dry" },

  // === WINE YEASTS — all stocked at Craft a Brew ===
  { id: "uvaferm43", name: "Lallemand UVAFERM 43", cat: "wine", abvMin: 0, abvMax: 16, tempMin: 59, tempMax: 86, optimal: 68, char: "Quick start, neutral, dry", note: "Fast and reliable — strong fermenter for high-gravity meads", price: 3.99, handle: "lallemand-uvaferm-43-dry-wine-yeast", cab: true, yanDemand: 1.0, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "premier_cdb", name: "Red Star Premier Côte des Blancs", cat: "wine", abvMin: 0, abvMax: 14, tempMin: 50, tempMax: 86, optimal: 65, char: "Slow, fruit-forward", note: "Slower fermenter — preserves sweetness and fruit character (great for sweet melomels)", price: 1.79, handle: "red-star-premier-cote-des-blancs-yeast", cab: true, yanDemand: 1.0, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "premier_rouge", name: "Red Star Premier Rouge", cat: "wine", abvMin: 0, abvMax: 16, tempMin: 64, tempMax: 86, optimal: 72, char: "Color extraction, balanced", note: "Built for red wine — extracts color from dark fruit (great for blackberry, cherry, elderberry)", price: 1.79, handle: "red-star-premier-rouge-yeast", cab: true, yanDemand: 1.1, packetWeight: "5g", cellsB: 6, form: "dry" },

  // === CHAMPAGNE — all stocked at Craft a Brew ===
  { id: "premier_cuvee", name: "Red Star Premier Cuvée", cat: "champagne", abvMin: 0, abvMax: 18, tempMin: 50, tempMax: 86, optimal: 65, char: "Fast, neutral, dry", note: "Workhorse — finishes 100% dry quickly, low foam", price: 1.79, handle: "red-star-premier-cuvee-yeast", cab: true, yanDemand: 0.7, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "premier_blanc", name: "Red Star Premier Blanc", cat: "champagne", abvMin: 0, abvMax: 18, tempMin: 50, tempMax: 86, optimal: 65, char: "Crisp, very dry", note: "Cold-tolerant champagne strain — clean finish at lower temps", price: 1.79, handle: "red-star-premier-blanc-yeast", cab: true, yanDemand: 0.7, packetWeight: "5g", cellsB: 6, form: "dry" },
  { id: "premier_classique", name: "Red Star Premier Classique", cat: "champagne", abvMin: 0, abvMax: 15, tempMin: 59, tempMax: 86, optimal: 68, char: "Strong, balanced, full-bodied", note: "Classic Montrachet strain — round mouthfeel, reliable for traditional meads", price: 1.69, handle: "red-star-premier-classique-yeast", cab: true, yanDemand: 0.9, packetWeight: "5g", cellsB: 6, form: "dry" }
];

// ===== STATE =====
var recipe = {
  type: "traditional",
  batchSize: 1,
  targetABV: 11.0,
  sweetness: 0,
  backsweetFG: 1.000,
  honeys: [],
  fruits: [],
  spices: [],
  yeast: null,
  nutrientProtocol: "cab",
  timelineDays: 30,
  fermTemp: 68
};

var SWEETNESS_LABELS = ["Dry", "Off-Dry", "Semi-Sweet", "Sweet"];
var SWEETNESS_FG = [1.000, 1.010, 1.020, 1.030];

/* ============================================================
   CALCULATION ENGINE
   ============================================================ */

// Calculate gravity contribution: PPG × pounds / batchSize (in gallons)
// Returns gravity points (e.g. 87 = 1.087)
function calcHoneyGravityPoints() {
  var points = 0;
  recipe.honeys.forEach(function(h) {
    var honey = HONEYS.find(function(x) { return x.id === h.honeyId; });
    if (!honey) return;
    points += (honey.ppg * h.amount) / recipe.batchSize;
  });
  return points;
}

// Calculate fruit/juice gravity contribution (approximate — fruit sugar is mostly fermentable)
function calcFruitGravityPoints() {
  var points = 0;
  // Compute total liquid volume from juices to enforce physical batch-size limit
  var totalJuiceGal = 0;
  recipe.fruits.forEach(function(f) {
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (fruit && fruit.isJuice) totalJuiceGal += f.amount / 4; // 4 qt per gal
  });
  // Cap juice volume at batch size — leaves no room for honey if exceeded
  var juiceCap = Math.min(1, recipe.batchSize / Math.max(0.001, totalJuiceGal));

  recipe.fruits.forEach(function(f) {
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (!fruit) return;
    var amount = fruit.isJuice ? f.amount * juiceCap : f.amount; // cap juices proportionally
    var weightLb = fruit.isJuice ? amount * (fruit.lbPerQt || 2.2) : amount;
    var sugarLb = weightLb * (fruit.sugar / 100);
    points += (46 * sugarLb) / recipe.batchSize;
  });
  return points;
}

// Recommended honey weight to hit target ABV given current fruit additions
function recommendHoneyWeight() {
  // ABV ≈ (OG_points - FG_points) × 0.131 (standard formula)
  // Need OG_points = (targetABV / 0.131) + FG_points + backsweetenAdjust
  var fgPoints = SWEETNESS_FG[recipe.sweetness] * 1000 - 1000;
  var targetOgPoints = (recipe.targetABV / 0.131) + fgPoints;
  // Subtract fruit contribution
  var fruitPoints = calcFruitGravityPoints();
  var honeyPointsNeeded = Math.max(0, targetOgPoints - fruitPoints);
  // Convert to pounds — 35 PPG average
  var avgPPG = 35;
  if (recipe.honeys.length) {
    var totalPpg = 0, n = 0;
    recipe.honeys.forEach(function(h) {
      var honey = HONEYS.find(function(x) { return x.id === h.honeyId; });
      if (honey) { totalPpg += honey.ppg; n++; }
    });
    if (n) avgPPG = totalPpg / n;
  }
  return (honeyPointsNeeded * recipe.batchSize) / avgPPG;
}

// Total honey weight currently in recipe
function totalHoneyWeight() {
  return recipe.honeys.reduce(function(sum, h) { return sum + h.amount; }, 0);
}

// Calculate backsweetening honey for sweetness > Dry
function calcBacksweetenHoney() {
  var targetFG = recipe.backsweetFG || 1.000;
  if (targetFG <= 1.000) return 0;
  var pointsToAdd = (targetFG - 1.000) * 1000;
  var lbsHoneyNeeded = (pointsToAdd * recipe.batchSize) / 35;
  return lbsHoneyNeeded;
}

// Recommend yeasts based on current ABV target
function recommendYeasts() {
  // Detect apple-based recipes — 71B converts malic acid to ethanol and strips apple flavor
  var hasApple = recipe.type === 'cyser' || recipe.fruits.some(function(f) {
    return f.fruitId === 'apple_juice' || f.fruitId === 'raw_cider' || f.fruitId === 'apple';
  });
  var candidates = YEASTS.filter(function(y) {
    if (y.abvMax < recipe.targetABV - 0.5) return false;
    if (hasApple && y.id === '71b1122') return false; // BC: 71B destroys apple character
    return true;
  });
  // Sort: CAB-stocked first, then by closeness of abvMax to target (don't over-yeast)
  candidates.sort(function(a, b) {
    if (a.cab !== b.cab) return a.cab ? -1 : 1;
    var aDiff = Math.abs(a.abvMax - recipe.targetABV - 2);
    var bDiff = Math.abs(b.abvMax - recipe.targetABV - 2);
    return aDiff - bDiff;
  });
  return candidates.slice(0, 3);
}

/* ============================================================
   RENDER FUNCTIONS
   ============================================================ */

function renderHoneyRows() {
  var body = document.getElementById('honeyBody');
  body.innerHTML = '';
  if (recipe.honeys.length === 0) {
    // Auto-add a default honey row to start
    recipe.honeys.push({ honeyId: 'cab_orange', amount: 2.5 });
  }
  recipe.honeys.forEach(function(h, idx) {
    var honey = HONEYS.find(function(x) { return x.id === h.honeyId; });
    var optsHtml = '<option value="">Select honey...</option>';
    var grouped = { cab: [], generic: [] };
    HONEYS.forEach(function(hh) { (hh.cab ? grouped.cab : grouped.generic).push(hh); });
    optsHtml += '<optgroup label="Craft a Brew">';
    grouped.cab.forEach(function(hh) {
      optsHtml += '<option value="'+hh.id+'"'+(h.honeyId===hh.id?' selected':'')+'>'+hh.name+'</option>';
    });
    optsHtml += '</optgroup><optgroup label="Other Varieties">';
    grouped.generic.forEach(function(hh) {
      optsHtml += '<option value="'+hh.id+'"'+(h.honeyId===hh.id?' selected':'')+'>'+hh.name+'</option>';
    });
    optsHtml += '</optgroup>';

    var tr = document.createElement('tr');
    tr.innerHTML =
      '<td><select class="ingredient-select" onchange="updateHoneyRow('+idx+', \'honeyId\', this.value)">'+optsHtml+'</select>'+
      (honey ? '<div class="ingredient-meta"><strong>'+honey.ppg+' PPG</strong> &middot; '+honey.flavor+'</div>' : '')+
      '</td>'+
      '<td class="cell-amount"><input type="number" class="amount-input" value="'+h.amount+'" min="0.1" step="0.1" oninput="updateHoneyAmountLive('+idx+', \'amount\', parseFloat(this.value))"><span class="unit-label">lb</span></td>'+
      '<td class="cell-ppg">'+(honey ? '<strong>'+honey.ppg+' PPG</strong>' : '—')+'</td>'+
      '<td class="cell-actions"><button class="remove-btn" onclick="removeHoney('+idx+')">×</button></td>';
    body.appendChild(tr);
  });
  document.getElementById('honeyBadge').textContent = totalHoneyWeight().toFixed(1) + ' lb';
}

function addHoneyDeprecated_DoNotUse() {
  // intentionally orphaned to remove the duplicate - kept name unique to avoid breaks if referenced
  return;
}
// Live handlers for amount inputs — update state + slider sync without re-rendering
// the row (preserves cursor/focus while user types). Full row re-render happens on
// dropdown change or remove, where focus loss doesn't matter.
function updateHoneyAmountLive(idx, key, val) {
  if (isNaN(val)) return;
  recipe.honeys[idx][key] = val;
  syncTargetABVFromHoney();
  // Update derived displays without re-rendering rows
  document.getElementById('honeyBadge').textContent = totalHoneyWeight().toFixed(1) + ' lb';
  recalculate();
}
function updateFruitAmountLive(idx, key, val) {
  if (isNaN(val)) return;
  recipe.fruits[idx][key] = val;
  syncTargetABVFromHoney();
  recalculate();
  // Update juice overfill warning without full re-render (preserves focus)
  checkJuiceOverfill();
}
function updateSpiceAmountLive(idx, key, val) {
  if (isNaN(val)) return;
  recipe.spices[idx][key] = val;
  recalculate();
}

// Standalone juice overfill check (called from live amount updates)
function checkJuiceOverfill() {
  var totalJuiceGal = 0;
  recipe.fruits.forEach(function(f) {
    var fr = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (fr && fr.isJuice) totalJuiceGal += f.amount / 4;
  });
  var overFill = totalJuiceGal > recipe.batchSize;
  var existing = document.getElementById('fruitOverfillWarn');
  if (existing) existing.remove();
  if (overFill) {
    var warn = document.createElement('div');
    warn.id = 'fruitOverfillWarn';
    warn.style.cssText = 'background:#fdeaea;color:#c0392b;border-left:3px solid var(--danger);padding:8px 12px;border-radius:0 6px 6px 0;margin-top:10px;font-size:0.78rem;';
    warn.innerHTML = '⚠️ <strong>Juice volume (' + totalJuiceGal.toFixed(1) + ' gal) exceeds batch size (' + recipe.batchSize + ' gal).</strong> Calculations are capped to fit. Reduce juice amount or increase batch size for accuracy.';
    var fruitCard = document.getElementById('fruitBody');
    if (fruitCard) fruitCard.parentElement.appendChild(warn);
  }
}

function updateHoneyRow(idx, key, val) {
  recipe.honeys[idx][key] = val;
  // User manually changed honey: recompute targetABV from actual sugar load instead of fighting them
  syncTargetABVFromHoney();
  renderHoneyRows();
  recalculate();
}
function removeHoney(idx) {
  recipe.honeys.splice(idx, 1);
  if (recipe.honeys.length === 0) recipe.honeys.push({ honeyId: 'cab_orange', amount: 2.5 });
  syncTargetABVFromHoney();
  renderHoneyRows();
  recalculate();
}
function addHoney() {
  recipe.honeys.push({ honeyId: 'cab_wildflower', amount: 1.0 });
  syncTargetABVFromHoney();
  renderHoneyRows();
  recalculate();
}

// When user manually changes honey (or fruit) inputs, the ABV slider re-orients
// to match the actual sugar load rather than fighting their input.
function syncTargetABVFromHoney() {
  var ogPoints = calcHoneyGravityPoints() + calcFruitGravityPoints();
  var actualABV = ogPoints * 0.131;
  var clamped = Math.max(4, Math.min(18, actualABV));
  recipe.targetABV = Math.round(clamped * 2) / 2; // round to 0.5 step
  var slider = document.getElementById('abvSlider');
  var label = document.getElementById('abvValue');
  if (slider) slider.value = recipe.targetABV;
  if (label) label.textContent = recipe.targetABV.toFixed(1) + '%';
}

function renderFruitRows() {
  var body = document.getElementById('fruitBody');
  body.innerHTML = '';
  // Detect over-fill
  var totalJuiceGal = 0;
  recipe.fruits.forEach(function(f) {
    var fr = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (fr && fr.isJuice) totalJuiceGal += f.amount / 4;
  });
  var overFill = totalJuiceGal > recipe.batchSize;
  recipe.fruits.forEach(function(f, idx) {
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    var optsHtml = '<option value="">Select fruit/juice...</option>';
    var fresh = FRUITS.filter(function(x) { return !x.isJuice && x.id !== 'raisin' && x.id !== 'date'; });
    var juice = FRUITS.filter(function(x) { return x.isJuice; });
    var dried = FRUITS.filter(function(x) { return x.id === 'raisin' || x.id === 'date'; });
    optsHtml += '<optgroup label="Fresh Fruit">';
    fresh.forEach(function(ff) { optsHtml += '<option value="'+ff.id+'"'+(f.fruitId===ff.id?' selected':'')+'>'+ff.name+'</option>'; });
    optsHtml += '</optgroup><optgroup label="Juice">';
    juice.forEach(function(ff) { optsHtml += '<option value="'+ff.id+'"'+(f.fruitId===ff.id?' selected':'')+'>'+ff.name+'</option>'; });
    optsHtml += '</optgroup><optgroup label="Dried">';
    dried.forEach(function(ff) { optsHtml += '<option value="'+ff.id+'"'+(f.fruitId===ff.id?' selected':'')+'>'+ff.name+'</option>'; });
    optsHtml += '</optgroup>';

    var sugarStr = '—';
    if (fruit) {
      var amount = f.amount;
      var weightLb = fruit.isJuice ? amount * (fruit.lbPerQt || 2.2) : amount;
      var sugarLb = weightLb * (fruit.sugar / 100);
      var sugarOz = sugarLb * 16;
      var gravPoints = (46 * sugarLb) / recipe.batchSize;
      if (sugarOz < 8) {
        sugarStr = sugarOz.toFixed(1) + ' oz sugar (+' + gravPoints.toFixed(0) + ' pts)';
      } else {
        sugarStr = sugarLb.toFixed(2) + ' lb sugar (+' + gravPoints.toFixed(0) + ' pts)';
      }
    }

    var tr = document.createElement('tr');
    tr.innerHTML =
      '<td><select class="ingredient-select" onchange="updateFruitRow('+idx+', \'fruitId\', this.value)">'+optsHtml+'</select>'+
      (fruit ? '<div class="ingredient-meta"><strong>'+fruit.sugar.toFixed(1)+'%</strong> sugar by weight</div>' : '')+
      '</td>'+
      '<td><input type="number" class="amount-input" value="'+f.amount+'" min="0.1" step="0.1" oninput="updateFruitAmountLive('+idx+', \'amount\', parseFloat(this.value))"><span class="unit-label">'+(fruit ? fruit.unit : 'lb')+'</span></td>'+
      '<td>'+sugarStr+'</td>'+
      '<td><button class="remove-btn" onclick="removeFruit('+idx+')">×</button></td>';
    body.appendChild(tr);
  });
  document.getElementById('fruitBadge').textContent = recipe.fruits.length + ' items';
  // Show overfill warning if total juice > batch size
  var existing = document.getElementById('fruitOverfillWarn');
  if (existing) existing.remove();
  if (overFill) {
    var warn = document.createElement('div');
    warn.id = 'fruitOverfillWarn';
    warn.style.cssText = 'background:#fdeaea;color:#c0392b;border-left:3px solid var(--danger);padding:8px 12px;border-radius:0 6px 6px 0;margin-top:10px;font-size:0.78rem;';
    warn.innerHTML = '⚠️ <strong>Juice volume ('+totalJuiceGal.toFixed(1)+' gal) exceeds batch size ('+recipe.batchSize+' gal).</strong> Calculations are capped to fit. Reduce juice amount or increase batch size for accuracy.';
    body.parentElement.appendChild(warn);
  }
}
function addFruit() {
  recipe.fruits.push({ fruitId: 'raspberry', amount: 2 });
  renderFruitRows();
  syncTargetABVFromHoney();
  recalculate();
}
function updateFruitRow(idx, key, val) {
  recipe.fruits[idx][key] = val;
  renderFruitRows();
  syncTargetABVFromHoney();
  recalculate();
}
function removeFruit(idx) {
  recipe.fruits.splice(idx, 1);
  renderFruitRows();
  syncTargetABVFromHoney();
  recalculate();
}

function renderSpiceRows() {
  var body = document.getElementById('spiceBody');
  body.innerHTML = '';
  recipe.spices.forEach(function(s, idx) {
    var spice = SPICES.find(function(x) { return x.id === s.spiceId; });
    var optsHtml = '<option value="">Select spice...</option>';
    SPICES.forEach(function(sp) { optsHtml += '<option value="'+sp.id+'"'+(s.spiceId===sp.id?' selected':'')+'>'+sp.name+'</option>'; });
    var tr = document.createElement('tr');
    tr.innerHTML =
      '<td><select class="ingredient-select" onchange="updateSpiceRow('+idx+', \'spiceId\', this.value)">'+optsHtml+'</select></td>'+
      '<td><input type="number" class="amount-input" value="'+s.amount+'" min="0.5" step="0.5" oninput="updateSpiceAmountLive('+idx+', \'amount\', parseFloat(this.value))"><span class="unit-label">'+(spice ? spice.unit : '')+'</span></td>'+
      '<td style="font-size:0.78rem;color:var(--text-muted);">'+(spice ? spice.note : '')+'</td>'+
      '<td><button class="remove-btn" onclick="removeSpice('+idx+')">×</button></td>';
    body.appendChild(tr);
  });
  document.getElementById('spiceBadge').textContent = recipe.spices.length + ' items';
}
function addSpice() {
  recipe.spices.push({ spiceId: 'cinnamon_stick', amount: 1 });
  renderSpiceRows();
  recalculate();
}
function updateSpiceRow(idx, key, val) {
  recipe.spices[idx][key] = val;
  renderSpiceRows();
  recalculate();
}
function removeSpice(idx) {
  recipe.spices.splice(idx, 1);
  renderSpiceRows();
  recalculate();
}

function renderYeastRecommendations() {
  var grid = document.getElementById('yeastRecGrid');
  grid.innerHTML = '';
  var recs = recommendYeasts();
  recs.forEach(function(y) {
    var div = document.createElement('div');
    div.className = 'yeast-rec-card' + (recipe.yeast && recipe.yeast.id === y.id ? ' active' : '');
    div.onclick = function() { selectYeast(y.id); };
    var tag = y.cab ? '<span class="yeast-rec-tag">In Stock</span>' : '<span class="yeast-rec-tag warn">Special Order</span>';
    div.innerHTML =
      '<div class="yeast-rec-name">'+y.name+'</div>'+
      '<div class="yeast-rec-meta">Up to '+y.abvMax+'% ABV · '+y.char+'</div>'+
      tag;
    grid.appendChild(div);
  });
}

function toggleYeastFull() {
  var section = document.getElementById('yeastFullSection');
  var btn = document.getElementById('yeastExpandBtn');
  if (section.style.display === 'none') {
    section.style.display = 'block';
    btn.textContent = '▴ Hide full yeast list';
    filterYeastCategory('mead');
  } else {
    section.style.display = 'none';
    btn.textContent = '▾ Show all yeasts (browse by category)';
  }
}

function filterYeastCategory(cat) {
  document.querySelectorAll('.yeast-toggle-btn').forEach(function(b) {
    b.classList.toggle('active', b.dataset.cat === cat);
  });
  var sel = document.getElementById('yeastFullSelect');
  var filtered = YEASTS.filter(function(y) { return y.cat === cat; });
  var html = '<option value="">Select a yeast strain...</option>';
  filtered.forEach(function(y) {
    var label = y.name + ' (up to ' + y.abvMax + '% ABV)';
    html += '<option value="'+y.id+'">'+label+'</option>';
  });
  sel.innerHTML = html;
}

function selectYeastFromDropdown() {
  var id = document.getElementById('yeastFullSelect').value;
  if (id) selectYeast(id);
}

function selectYeast(id) {
  var y = YEASTS.find(function(x) { return x.id === id; });
  if (!y) return;
  recipe.yeast = y;
  document.getElementById('yeastBadge').textContent = y.name;
  document.getElementById('yeastInfoGrid').style.display = 'grid';
  document.getElementById('yeastABV').textContent = y.abvMax + '%';
  document.getElementById('yeastTemp').textContent = y.tempMin + '–' + y.tempMax + '°F';
  document.getElementById('yeastChar').textContent = y.char;
  renderYeastRecommendations();
  renderYeastPacketInfo();
  recalculate();
}

// === Yeast packet info: weight, cell count, packet recommendation ===
// Per BC mead maker: dry mead/wine yeast (5g) packets are dosed by BATCH SIZE only,
// not by OG. One 5g packet covers up to 5 gallons across the full mead OG range.
// Larger batches need additional packets (or rehydrate with Go-Ferm). Beer yeast and
// liquid yeast are exceptions — they're more pitch-rate sensitive.
function renderYeastPacketInfo() {
  var box = document.getElementById('yeastPacketInfo');
  var txt = document.getElementById('yeastPacketText');
  var rec = document.getElementById('yeastPacketRec');
  if (!recipe.yeast || !recipe.yeast.packetWeight) {
    box.style.display = 'none';
    return;
  }
  var y = recipe.yeast;
  var honeyPoints = calcHoneyGravityPoints();
  var fruitPoints = calcFruitGravityPoints();
  var ogPoints = honeyPoints + fruitPoints;
  var og = 1 + ogPoints / 1000;
  var batch = recipe.batchSize;

  var packetsNeeded;
  var note = '';

  // All CAB-stocked mead yeasts are dry — 1 packet covers up to 5 gal regardless of OG (per BC).
  // Add one packet per additional 5 gal of batch size.
  packetsNeeded = Math.max(1, Math.ceil(batch / 5));

  txt.innerHTML = '<strong>' + y.packetWeight + ' dry packet</strong>, ~' + y.cellsB + 'B cells' +
                  (note ? ' &middot; <em style="color:var(--text-muted);">' + note + '</em>' : '');
  if (packetsNeeded === 1) {
    rec.className = 'packet-rec';
    rec.textContent = '1 packet sufficient';
  } else {
    rec.className = 'packet-rec warn';
    rec.textContent = packetsNeeded + ' packets recommended';
  }
  box.style.display = 'flex';
}

/* ============================================================
   NUTRIENT SCHEDULE RENDER
   ============================================================ */

function renderNutrientSchedule() {
  var sched = document.getElementById('nutrientSchedule');
  var batch = recipe.batchSize;
  document.getElementById('nutrientBadge').textContent = recipe.nutrientProtocol === 'cab' ? 'CAB Blend' : 'TOSNA 3.0';

  // OG-based and yeast-YAN-based scaling. Calibration anchor: CAB published dose
  // (5.3g + 3.3g + 3.3g per gal) is for 1.087 OG with medium-YAN yeast (D-47, etc).
  // Per BC: a 4% ABV mead with EC-1118 (low YAN) needs only ~2.5g total per gal.
  // BC Apr 2026: linear scaling over-doses by ~2x for sub-8% ABV recipes.
  // Fix: use sub-linear (squared) curve below anchor so low-gravity meads get
  // proportionally less nutrient. Floor at 0.30 prevents negligible doses.
  var honeyPoints = calcHoneyGravityPoints();
  var fruitPoints = calcFruitGravityPoints();
  var ogPoints = honeyPoints + fruitPoints;
  var ogRatio = ogPoints / 87; // 1.0 at anchor OG
  var ogFactor;
  if (ogRatio >= 1) {
    ogFactor = Math.min(1.7, ogRatio); // linear above anchor
  } else {
    // Squared curve below anchor — drops faster for low gravity
    // At 8% ABV (~0.70 ratio): 0.49 → ~40% less than linear
    // At 4% ABV (~0.35 ratio): floor 0.30 catches it → ~2.5g/gal with EC-1118
    ogFactor = Math.max(0.30, ogRatio * ogRatio);
  }
  // YAN demand factor from yeast (defaults to 1.0 if no yeast or no field)
  var yanFactor = (recipe.yeast && recipe.yeast.yanDemand) ? recipe.yeast.yanDemand : 1.0;
  var scale = ogFactor * yanFactor;

  if (recipe.nutrientProtocol === 'cab') {
    var d1 = (5.3 * batch * scale).toFixed(1);
    var d25 = (3.3 * batch * scale).toFixed(1);
    var totalG = (parseFloat(d1) + parseFloat(d25) * 2).toFixed(1);
    var scaleNote = scale < 0.95 ? 'Reduced from base dose (low OG / low-YAN yeast).'
                  : scale > 1.15 ? 'Increased from base dose (high OG / high-YAN yeast).'
                  : 'Standard CAB Mead Kit dose for this OG and yeast.';
    sched.innerHTML =
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">Day</span><span class="day-n">1</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">CAB Day 1 Mead Yeast Nutrient</div>'+
          '<div class="nutrient-day-amount">'+d1+' g</div>'+
          '<div class="nutrient-day-note">DAP + Fermaid K + Potassium Carbonate. Add to fermenter <strong>before</strong> topping off with water. Swirl to dissolve.</div>'+
        '</div>'+
      '</div>'+
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">Day</span><span class="day-n">2</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">CAB Day 2/5 Mead Yeast Nutrient</div>'+
          '<div class="nutrient-day-amount">'+d25+' g</div>'+
          '<div class="nutrient-day-note">DAP + Fermaid K. Degas first, then sprinkle in <em>tiny increments</em> to avoid foam-over.</div>'+
        '</div>'+
      '</div>'+
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">Day</span><span class="day-n">5</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">CAB Day 2/5 Mead Yeast Nutrient</div>'+
          '<div class="nutrient-day-amount">'+d25+' g</div>'+
          '<div class="nutrient-day-note">Same as Day 2 — degas first, add slowly.</div>'+
        '</div>'+
      '</div>'+
      '<div style="margin-top:14px;padding:10px 12px;background:var(--bg-card);border-radius:8px;font-size:0.78rem;color:var(--text-muted);">'+
        '<strong style="color:var(--honey-deep);">Total: '+totalG+'g per batch.</strong> '+scaleNote+
      '</div>';
  } else {
    // TOSNA: ~1.25g Fermaid-O per gal at 1.087 standard, scaled by OG and YAN
    var doseG = (1.25 * batch * scale).toFixed(1);
    var totalG = (doseG * 4).toFixed(1);
    var scaleNote = scale < 0.95 ? 'Reduced from base dose (low OG / low-YAN yeast).'
                  : scale > 1.15 ? 'Increased from base dose (high OG / high-YAN yeast).'
                  : 'Standard TOSNA dose for this OG and yeast.';
    sched.innerHTML =
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">Day</span><span class="day-n">0</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">Fermaid-O (organic only — no DAP)</div>'+
          '<div class="nutrient-day-amount">'+doseG+' g</div>'+
          '<div class="nutrient-day-note">Add immediately after pitching yeast.</div>'+
        '</div>'+
      '</div>'+
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">Day</span><span class="day-n">1</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">Fermaid-O (24 hours)</div>'+
          '<div class="nutrient-day-amount">'+doseG+' g</div>'+
          '<div class="nutrient-day-note">Degas gently, then sprinkle.</div>'+
        '</div>'+
      '</div>'+
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">Day</span><span class="day-n">2</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">Fermaid-O (48 hours)</div>'+
          '<div class="nutrient-day-amount">'+doseG+' g</div>'+
          '<div class="nutrient-day-note">Third dose. Degas and sprinkle as before.</div>'+
        '</div>'+
      '</div>'+
      '<div class="nutrient-day">'+
        '<div class="nutrient-day-num"><span class="day-label">⅓</span><span class="day-n">SB</span></div>'+
        '<div class="nutrient-day-body">'+
          '<div class="nutrient-day-product">Fermaid-O (⅓ sugar break)</div>'+
          '<div class="nutrient-day-amount">'+doseG+' g</div>'+
          '<div class="nutrient-day-note">Final dose when gravity drops ⅓ of the way from OG to FG.</div>'+
        '</div>'+
      '</div>'+
      '<div style="margin-top:14px;padding:10px 12px;background:var(--bg-card);border-radius:8px;font-size:0.78rem;color:var(--text-muted);">'+
        '<strong style="color:var(--honey-deep);">Total: '+totalG+'g Fermaid-O per batch.</strong> '+scaleNote+' TOSNA = Tailored Organic Staggered Nutrient Additions.'+
      '</div>';
  }
}

function selectNutrientProtocol(p) {
  recipe.nutrientProtocol = p;
  document.querySelectorAll('.nutrient-toggle-btn').forEach(function(b) {
    b.classList.toggle('active', b.dataset.protocol === p);
  });
  recalculate(); // refreshes cart, chart markers, and phase grid
}

/* ============================================================
   TIMELINE: chart + phase cards
   ============================================================ */

function renderTimelineChart() {
  var canvas = document.getElementById('fermChart');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var rect = canvas.parentElement.getBoundingClientRect();
  canvas.width = rect.width * 2;
  canvas.height = 180 * 2;
  canvas.style.width = rect.width + 'px';
  canvas.style.height = '180px';
  ctx.scale(2, 2);
  var W = rect.width, H = 180;
  ctx.clearRect(0, 0, W, H);

  var days = recipe.timelineDays;
  var ogPoints = parseFloat(document.getElementById('tlOG').textContent) * 1000 - 1000;
  // Primary fermentation always runs to FG 1.000 — the chart shows primary, not backsweetening
  var fgPoints = 0;
  var padL = 32, padR = 36, padT = 28, padB = 22;

  // Background gridlines
  ctx.strokeStyle = '#f0ece4'; ctx.lineWidth = 1;
  for (var i = 0; i <= 4; i++) {
    var y = padT + ((H - padT - padB) * i / 4);
    ctx.beginPath(); ctx.moveTo(padL, y); ctx.lineTo(W - padR, y); ctx.stroke();
  }

  // === ACCURATE & SMOOTH FERMENTATION MODEL ===
  // Calibration target (per mead maker BC): standard 1.087 mead with wine yeast
  // finishes primary fermentation in ~14-18 days. High-gravity melomel ~21 days.
  // Sack mead (1.140) ~28-35 days. Cold-fermented or stressed yeast extends.
  function getGravityAtDay(d) {
    var tempFactor = 1;
    var stressMultiplier = 1;
    var yeastABV = 14;
    if (recipe.yeast) {
      var optimal = recipe.yeast.optimal || 65;
      var diff = recipe.fermTemp - optimal;
      if (diff > 0) {
        tempFactor = Math.max(0.5, 1 - diff * 0.025);
      } else {
        var below = recipe.yeast.tempMin - recipe.fermTemp;
        tempFactor = 1 + (-diff * 0.04) + (below > 0 ? below * 0.06 : 0);
      }
      yeastABV = recipe.yeast.abvMax;
      var headroom = yeastABV - recipe.targetABV;
      if (headroom < 1) stressMultiplier = 2.0;
      else if (headroom < 3) stressMultiplier = 1.4;
      else if (headroom < 5) stressMultiplier = 1.15;
    }
    // Calibrated: 1.087 → ~16 active days, 1.140 → ~28 active days, 1.050 → ~10 active days
    var activeDays = (4 + ogPoints * 0.135) * stressMultiplier * tempFactor;
    var tau = activeDays / 2.06;
    var n = 1.6;
    var prog = 1 - Math.exp(-Math.pow(d / tau, n));
    var maxProg = (yeastABV - recipe.targetABV) < 1 ? 0.92 : 0.995;
    prog = Math.min(maxProg, prog);
    return ogPoints - (ogPoints - fgPoints) * prog;
  }

  // Plot specific gravity (gold) on left axis
  ctx.strokeStyle = '#E8A832'; ctx.lineWidth = 2.8; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  ctx.beginPath();
  for (var d = 0; d <= days; d++) {
    var grav = getGravityAtDay(d);
    var x = padL + (W - padL - padR) * (d/days);
    var yPct = (ogPoints > 0) ? (1 - (grav / ogPoints)) : 0;
    var y = padT + (H - padT - padB) * yPct;
    if (d === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
  }
  ctx.stroke();

  // Plot ABV % (green) on right axis — climbs as gravity falls
  var maxABV = Math.max(recipe.targetABV, ogPoints * 0.131);
  ctx.strokeStyle = '#4abe5e'; ctx.lineWidth = 2.4; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  ctx.setLineDash([5, 4]);
  ctx.beginPath();
  for (var d = 0; d <= days; d++) {
    var grav = getGravityAtDay(d);
    var abv = (ogPoints - grav) * 0.131;
    var x = padL + (W - padL - padR) * (d/days);
    var yPct = 1 - (abv / maxABV);
    var y = padT + (H - padT - padB) * yPct;
    if (d === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
  }
  ctx.stroke();
  ctx.setLineDash([]);

  // Y-axis labels: SG on left (primary always finishes 1.000), ABV on right
  ctx.fillStyle = '#7a756d'; ctx.font = '9px DM Sans, sans-serif';
  ctx.textAlign = 'right'; ctx.textBaseline = 'middle';
  ctx.fillStyle = '#c4882a';
  ctx.fillText((1 + ogPoints/1000).toFixed(3), padL - 4, padT);
  ctx.fillText('1.000', padL - 4, H - padB);
  ctx.textAlign = 'left';
  ctx.fillStyle = '#2d8a3e';
  ctx.fillText(maxABV.toFixed(1) + '%', W - padR + 4, padT);
  ctx.fillText('0%', W - padR + 4, H - padB);

  // === Nutrient addition flag chips — STAGGERED vertically to avoid overlap ===
  var nutDays = recipe.nutrientProtocol === 'cab'
    ? [{d:1,l:'Day 1'},{d:2,l:'Day 2'},{d:5,l:'Day 5'}]
    : [{d:0,l:'Day 0'},{d:1,l:'Day 1'},{d:2,l:'Day 2'},{d:7,l:'Day 7'}];
  var chipW = 42, chipH = 16;
  var chipsTopRow = padT + 6; // first chip closest to chart top
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  nutDays.forEach(function(n, i) {
    if (n.d > days) return;
    var x = padL + (W - padL - padR) * (n.d/days);
    // Stagger: each subsequent chip drops by chipH+4 px
    var chipY = chipsTopRow + i * (chipH + 4);
    var chipX = x - chipW/2;

    // Faint guide line from chip down to (or up to) curve at this day
    ctx.strokeStyle = 'rgba(139, 111, 191, 0.4)';
    ctx.lineWidth = 1;
    ctx.setLineDash([3, 3]);
    ctx.beginPath();
    ctx.moveTo(x, chipY + chipH + 2);
    ctx.lineTo(x, H - padB - 2);
    ctx.stroke();
    ctx.setLineDash([]);

    // Triangle pointer below chip pointing down at curve
    ctx.fillStyle = '#8B6FBF';
    ctx.beginPath();
    ctx.moveTo(x - 4, chipY + chipH);
    ctx.lineTo(x + 4, chipY + chipH);
    ctx.lineTo(x, chipY + chipH + 5);
    ctx.closePath();
    ctx.fill();

    // Chip body
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(chipX, chipY, chipW, chipH, 4);
    else ctx.rect(chipX, chipY, chipW, chipH);
    ctx.fill();

    // Day label inside chip
    ctx.fillStyle = '#fff';
    ctx.font = '700 9px DM Sans, sans-serif';
    ctx.fillText(n.l, x, chipY + chipH/2 + 0.5);
  });
  ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';

  // === Legend: SG (gold solid) + ABV (green dashed) + Nutrient (violet flag) ===
  ctx.font = '10px DM Sans';
  ctx.fillStyle = '#E8A832'; ctx.fillRect(padL, 10, 12, 3);
  ctx.fillStyle = '#7a756d'; ctx.fillText('Specific Gravity', padL + 18, 14);
  // ABV dashed line
  ctx.strokeStyle = '#4abe5e'; ctx.lineWidth = 2; ctx.setLineDash([4, 3]);
  ctx.beginPath(); ctx.moveTo(padL + 130, 11.5); ctx.lineTo(padL + 142, 11.5); ctx.stroke();
  ctx.setLineDash([]);
  ctx.fillStyle = '#7a756d'; ctx.fillText('ABV %', padL + 148, 14);
  // Nutrient flag
  ctx.fillStyle = '#8B6FBF';
  ctx.beginPath();
  if (ctx.roundRect) ctx.roundRect(padL + 198, 8, 14, 8, 2);
  else ctx.rect(padL + 198, 8, 14, 8);
  ctx.fill();
  ctx.fillStyle = '#7a756d'; ctx.fillText('Nutrient Addition', padL + 218, 14);

  // Render day axis labels in HTML (not in canvas)
  var axis = document.getElementById('timelineDayAxis');
  if (axis) {
    var marks = [0, Math.round(days/4), Math.round(days/2), Math.round(3*days/4), days];
    axis.innerHTML = marks.map(function(d) { return '<span>Day ' + d + '</span>'; }).join('');
  }

  // Expose curve fn for phase-stat interpolation
  window._fermCurve = getGravityAtDay;
}

function renderTempControl() {
  var rec = document.getElementById('tempRecommended');
  var status = document.getElementById('tempStatus');
  if (!recipe.yeast) {
    rec.textContent = 'Select yeast →';
    status.textContent = '—';
    status.className = 'temp-status';
    return;
  }
  var y = recipe.yeast;
  rec.textContent = y.tempMin + '–' + y.tempMax + '°F  (optimal ' + y.optimal + '°F)';
  var t = recipe.fermTemp;
  if (t >= y.tempMin && t <= y.tempMax) {
    var diff = Math.abs(t - y.optimal);
    if (diff <= 3) { status.textContent = '✓ Optimal — clean fermentation expected'; status.className = 'temp-status'; }
    else { status.textContent = '✓ Within range — slight off-flavor risk'; status.className = 'temp-status'; }
  } else if (t < y.tempMin) {
    status.textContent = '⚠ Too cold — fermentation may stall'; status.className = 'temp-status danger';
  } else {
    status.textContent = '⚠ Too warm — risk of fusels & off-flavors'; status.className = 'temp-status danger';
  }
}

function stepFermTemp(delta) {
  var inp = document.getElementById('fermTemp');
  var v = parseInt(inp.value) || 68;
  v = Math.max(40, Math.min(100, v + delta));
  inp.value = v;
  onFermTempChange();
}

function onFermTempChange() {
  recipe.fermTemp = parseInt(document.getElementById('fermTemp').value) || 68;
  renderTempControl();
  renderTimelineChart();
  renderTimelinePhases();
  // Recompute estimated days based on temp
  var baseDays = recipe.timelineDays;
  document.getElementById('tlDays').textContent = Math.round(estimateTotalDays());
}

function estimateTotalDays() {
  // Total = active duration + 5-day buffer to confirm stable SG
  var ogPoints = (parseFloat(document.getElementById('tlOG').textContent) - 1) * 1000;
  if (ogPoints <= 0) return 21;
  var stressMultiplier = 1;
  var tempFactor = 1;
  if (recipe.yeast) {
    var headroom = recipe.yeast.abvMax - recipe.targetABV;
    if (headroom < 1) stressMultiplier = 2.0;
    else if (headroom < 3) stressMultiplier = 1.4;
    else if (headroom < 5) stressMultiplier = 1.15;
    var diff = recipe.fermTemp - (recipe.yeast.optimal || 65);
    if (diff > 0) tempFactor = Math.max(0.5, 1 - diff * 0.025);
    else {
      var below = recipe.yeast.tempMin - recipe.fermTemp;
      tempFactor = 1 + (-diff * 0.04) + (below > 0 ? below * 0.06 : 0);
    }
  }
  var activeDays = (4 + ogPoints * 0.135) * stressMultiplier * tempFactor;
  return activeDays + 5;
}

function renderTimelinePhases() {
  var grid = document.getElementById('timelineGrid');
  var ogPoints = (parseFloat(document.getElementById('tlOG').textContent) - 1) * 1000;
  var curveFn = window._fermCurve || function() { return 0; };
  function gravAt(day) { return (1 + curveFn(day)/1000).toFixed(3); }
  function abvAt(day) { return ((ogPoints - curveFn(day)) * 0.131).toFixed(1); }
  var totalDays = estimateTotalDays();

  // Compute day ranges for each phase by inverting the Weibull curve.
  // Active Phase: 5%–80% progress. Clearing: 80%–99% progress.
  function dayAtProg(p) {
    var stress = 1, tf = 1;
    if (recipe.yeast) {
      var hr = recipe.yeast.abvMax - recipe.targetABV;
      stress = hr<1 ? 2.0 : hr<3 ? 1.4 : hr<5 ? 1.15 : 1;
      var diff = recipe.fermTemp - (recipe.yeast.optimal||65);
      if (diff > 0) tf = Math.max(0.5, 1 - diff*0.025);
      else { var below = recipe.yeast.tempMin - recipe.fermTemp; tf = 1 + (-diff*0.04) + (below>0 ? below*0.06 : 0); }
    }
    var activeDays = (4 + ogPoints*0.135) * stress * tf;
    var tau = activeDays / 2.06;
    return tau * Math.pow(-Math.log(1 - p), 1/1.6);
  }
  var activeStart = Math.max(1, Math.round(dayAtProg(0.05)));
  var activeEnd = Math.max(activeStart + 1, Math.round(dayAtProg(0.80)));
  var clearingEnd = Math.max(activeEnd + 1, Math.round(dayAtProg(0.99)));
  var stabilizeDay = Math.round(totalDays);

  var phases;
  if (recipe.nutrientProtocol === 'cab') {
    phases = [
      { sampleDay: 0, day: 'Day 0', icon: 'icon-yeast', title: 'Pitch Yeast', desc: 'Mix must, add Day 1 nutrients, pitch yeast, aerate.', variant: 'pitch' },
      { sampleDay: 1, day: 'Day 1', icon: 'icon-nutrient', title: 'Nutrient Add', desc: 'Degas. Add Day 1 nutrient dose.', variant: 'nutrient' },
      { sampleDay: 2, day: 'Day 2', icon: 'icon-nutrient', title: 'Nutrient Add', desc: 'Degas. Add second nutrient dose.', variant: 'nutrient' },
      { sampleDay: 5, day: 'Day 5', icon: 'icon-nutrient', title: 'Nutrient Add', desc: 'Final nutrient addition.', variant: 'nutrient' }
    ];
  } else {
    phases = [
      { sampleDay: 0, day: 'Day 0', icon: 'icon-yeast', title: 'Pitch + Nutrient', desc: 'Pitch yeast, aerate, add 1st Fermaid-O dose.', variant: 'pitch' },
      { sampleDay: 1, day: 'Day 1', icon: 'icon-nutrient', title: 'Nutrient Add', desc: 'Add 2nd Fermaid-O dose (24h).', variant: 'nutrient' },
      { sampleDay: 2, day: 'Day 2', icon: 'icon-nutrient', title: 'Nutrient Add', desc: 'Add 3rd Fermaid-O dose (48h).', variant: 'nutrient' },
      { sampleDay: 7, day: 'Day 7', icon: 'icon-nutrient', title: 'Nutrient Add', desc: 'Final dose at ⅓ sugar break.', variant: 'nutrient' }
    ];
  }
  // Closing phases — dynamic day ranges based on curve, not hardcoded text
  phases.push(
    { sampleDay: Math.round((activeStart + activeEnd) / 2),
      day: 'Days ' + activeStart + '–' + activeEnd,
      icon: 'icon-bubble', title: 'Active Ferment', desc: 'Vigorous bubbling. Don\'t open the airlock.', variant: 'active-ferment' },
    { sampleDay: Math.round((activeEnd + clearingEnd) / 2),
      day: 'Days ' + activeEnd + '–' + clearingEnd,
      icon: 'icon-cloud', title: 'Clearing', desc: 'Activity slows. Mead begins to clear.', variant: 'monitor' },
    { sampleDay: stabilizeDay,
      day: 'Day ' + stabilizeDay + '+',
      icon: 'icon-bottle', title: 'Stabilize & Bottle', desc: 'Stable SG over 3 days. Stabilize if backsweetening.', variant: 'complete' }
  );

  grid.innerHTML = '';
  phases.forEach(function(p) {
    var div = document.createElement('div');
    div.className = 'phase-card' + (p.variant ? ' ' + p.variant : '');
    div.innerHTML =
      '<div class="phase-icon"><svg class="cab-icon"><use href="#'+p.icon+'"/></svg></div>'+
      '<div class="phase-day">'+p.day+'</div>'+
      '<div class="phase-title">'+p.title+'</div>'+
      '<div class="phase-desc">'+p.desc+'</div>'+
      '<div class="phase-stats"><strong>SG:</strong> '+gravAt(p.sampleDay)+' &middot; <strong>ABV:</strong> '+abvAt(p.sampleDay)+'%</div>';
    grid.appendChild(div);
  });
}

function setTimelineScale(d) {
  recipe.timelineDays = d;
  document.querySelectorAll('.scale-btn').forEach(function(b) {
    b.classList.toggle('active', parseInt(b.dataset.days) === d);
  });
  // Note: tlDays (the "READY IN" stat) is NOT updated here.
  // It always shows the actual estimated completion, not the chart view scale.
  renderTimelineChart();
}

/* ============================================================
   CART
   ============================================================ */

// Find the cheapest combination of pouches that covers AT LEAST `needed` lbs.
// Brute-force over large-pouch counts then fill the remainder with small ones.
// Returns an array like [{pouch, count}, ...] sorted largest-first.
// BC May 2026 fix: honey is sold in fixed-size pouches (40 oz / 12 oz), NOT
// by the pound. The old code multiplied per-pouch price by Math.ceil(amount)
// which 3x'd the price of a normal 2.5 lb recipe.
function findOptimalPouchCombo(needed, pouches) {
  if (!pouches || pouches.length === 0) return null;
  if (needed <= 0.001) return [];
  var sorted = pouches.slice().sort(function(a, b) { return b.size - a.size; });
  var large = sorted[0];
  var small = sorted[1]; // may be undefined if only one size offered
  if (!small) {
    return [{ pouch: large, count: Math.ceil(needed / large.size) }];
  }
  var bestPrice = Infinity;
  var bestCombo = null;
  var maxLarge = Math.ceil(needed / large.size);
  for (var lc = 0; lc <= maxLarge; lc++) {
    var largeAmt = lc * large.size;
    var remainder = Math.max(0, needed - largeAmt);
    var sc = remainder > 0.001 ? Math.ceil(remainder / small.size) : 0;
    var totalAmt = largeAmt + sc * small.size;
    var totalPrice = lc * large.price + sc * small.price;
    if (totalAmt >= needed - 0.001 && totalPrice < bestPrice) {
      bestPrice = totalPrice;
      bestCombo = [];
      if (lc > 0) bestCombo.push({ pouch: large, count: lc });
      if (sc > 0) bestCombo.push({ pouch: small, count: sc });
    }
  }
  return bestCombo;
}

function renderCart() {
  var cart = [];
  var sum = 0;
  // Backsweetening honey gets added to the first honey row's total so the optimal
  // pouch calculation accounts for ALL the honey needed (primary + backsweetening),
  // not just primary. Most users backsweeten with the same honey as their primary.
  var backsweetLb = (recipe.backsweetFG > 1.002) ? calcBacksweetenHoney() : 0;
  recipe.honeys.forEach(function(h, idx) {
    var honey = HONEYS.find(function(x) { return x.id === h.honeyId; });
    if (!honey) return;
    var amountNeeded = h.amount + (idx === 0 ? backsweetLb : 0);
    // Generic honeys without pouches array: source locally (no price)
    if (!honey.pouches || honey.pouches.length === 0) {
      cart.push({ name: honey.name, qty: amountNeeded.toFixed(1) + ' lb', price: 0, hasHandle: false });
      return;
    }
    // CAB honeys: pick cheapest pouch combination for the requested weight
    var combo = findOptimalPouchCombo(amountNeeded, honey.pouches);
    if (!combo || combo.length === 0) return;
    combo.forEach(function(item) {
      var lineTotal = item.pouch.price * item.count;
      cart.push({
        name: honey.name + ' (' + item.pouch.label + ')',
        qty: 'x' + item.count,
        price: lineTotal,
        hasHandle: true,
        handle: item.pouch.handle
      });
      sum += lineTotal;
    });
  });
  recipe.fruits.forEach(function(f) {
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (!fruit) return;
    var qty = Math.ceil(f.amount);
    cart.push({ name: fruit.name, qty: qty + ' ' + fruit.unit, price: 0, hasHandle: false });
  });
  recipe.spices.forEach(function(s) {
    var spice = SPICES.find(function(x) { return x.id === s.spiceId; });
    if (!spice) return;
    var qty = Math.ceil(s.amount);
    var price = spice.price * Math.max(1, Math.ceil(qty / 5));
    cart.push({ name: spice.name, qty: qty + ' ' + spice.unit, price: price, hasHandle: false });
    sum += price;
  });
  // Muslin steeping bag for spice additions (per BC mead maker note)
  if (recipe.spices.length > 0) {
    cart.push({ name: 'Muslin Steeping Bag', qty: 'x1', price: 2.99, hasHandle: true, handle: 'muslin-bag-for-brewing' });
    sum += 2.99;
  }
  if (recipe.yeast) {
    // Match the packet logic in renderYeastPacketInfo: 1 dry packet per 5 gal.
    // Previously hardcoded to x1 which under-charged customers with batches > 5 gal.
    var packetsNeeded = recipe.yeast.packetWeight
      ? Math.max(1, Math.ceil(recipe.batchSize / 5))
      : 1;
    var yeastTotal = recipe.yeast.price * packetsNeeded;
    cart.push({
      name: recipe.yeast.name,
      qty: 'x' + packetsNeeded,
      price: yeastTotal,
      hasHandle: !!recipe.yeast.handle,
      handle: recipe.yeast.handle || null
    });
    sum += yeastTotal;
  }
  // Nutrient kit (CAB only — TOSNA needs Fermaid-O sourced separately)
  if (recipe.nutrientProtocol === 'cab') {
    cart.push({ name: 'CAB Mead Yeast Nutrient (Day 1 + Day 2/5)', qty: 'x1', price: 9.99, hasHandle: true, handle: 'mead-yeast-nutrient' });
    sum += 9.99;
  } else {
    cart.push({ name: 'Fermaid-O Yeast Nutrient', qty: 'x1', price: 12.99, hasHandle: false, handle: null });
    sum += 12.99;
  }
  // Mead Stabilizer for Backsweetening — single packet treats 1 gallon.
  // Replaces the previous Potassium Sorbate + Campden Tablets combo since the
  // Mead Stabilizer packet contains both (Potassium Sorbate + Potassium Metabisulfite)
  // in the correct pre-measured dose per gallon. Cheaper and simpler for users.
  if (recipe.backsweetFG > 1.002) {
    var stabilizerPackets = Math.max(1, Math.ceil(recipe.batchSize));
    var stabilizerPrice = 3.99 * stabilizerPackets;
    cart.push({
      name: 'Mead Stabilizer (Backsweetening)',
      qty: 'x' + stabilizerPackets,
      price: stabilizerPrice,
      hasHandle: true,
      handle: 'mead-stabilizer-for-backsweetening'
    });
    sum += stabilizerPrice;
  }

  var items = document.getElementById('cartItems');
  var total = document.getElementById('cartTotal');
  var btn = document.getElementById('cartBtn');
  // Split into purchasable (has handle) vs source-locally items
  var cabItems = [];
  var localItems = [];
  cart.forEach(function(c) {
    if (c.handle) cabItems.push(c);
    else localItems.push(c);
  });
  window._meadCart = cabItems; // Only CAB items are addable to cart
  if (cabItems.length === 0 && localItems.length === 0) {
    items.innerHTML = '<div class="cart-empty">Build your recipe to see ingredients</div>';
    total.style.display = 'none';
    btn.disabled = true;
  } else {
    var html = '';
    cabItems.forEach(function(c, idx) {
      var excluded = c._excluded;
      html += '<div class="cart-item'+(excluded ? ' cart-item-excluded' : '')+'" data-idx="'+idx+'">'+
        '<span class="cart-item-name">'+c.name+'</span>'+
        '<span class="cart-item-qty">'+c.qty+'</span>'+
        '<span class="cart-item-price">'+(c.price > 0 ? '$'+c.price.toFixed(2) : '—')+'</span>'+
        '<button class="cart-item-remove" onclick="toggleCartItem('+idx+')" title="'+(excluded ? 'Add back' : 'Remove — I already have this')+'">'+(excluded ? '+' : '×')+'</button>'+
      '</div>';
    });
    // Source locally section
    if (localItems.length > 0) {
      html += '<div class="cart-local-header">Source Locally</div>';
      localItems.forEach(function(c) {
        html += '<div class="cart-item cart-item-local">'+
          '<span class="cart-item-name">'+c.name+'</span>'+
          '<span class="cart-item-qty">'+c.qty+'</span>'+
          '<span class="cart-item-price cart-item-local-tag">—</span>'+
          '<span style="width:22px"></span>'+
        '</div>';
      });
    }
    items.innerHTML = html;
    // Total only counts CAB items
    var activeSum = 0;
    cabItems.forEach(function(c) { if (!c._excluded) activeSum += c.price; });
    document.getElementById('cartTotalValue').textContent = '$' + activeSum.toFixed(2);
    total.style.display = 'flex';
    btn.disabled = cabItems.length === 0;
  }
}

// Toggle individual cart items (user already has some items)
function toggleCartItem(idx) {
  if (!window._meadCart || !window._meadCart[idx]) return;
  window._meadCart[idx]._excluded = !window._meadCart[idx]._excluded;
  // Re-render just the CAB items section
  var items = document.getElementById('cartItems');
  var cart = window._meadCart;
  // Rebuild just the CAB portion; keep local items HTML intact
  var cabHtml = '';
  cart.forEach(function(c, i) {
    var excluded = c._excluded;
    cabHtml += '<div class="cart-item'+(excluded ? ' cart-item-excluded' : '')+'" data-idx="'+i+'">'+
      '<span class="cart-item-name">'+c.name+'</span>'+
      '<span class="cart-item-qty">'+c.qty+'</span>'+
      '<span class="cart-item-price">'+(c.price > 0 ? '$'+c.price.toFixed(2) : '—')+'</span>'+
      '<button class="cart-item-remove" onclick="toggleCartItem('+i+')" title="'+(excluded ? 'Add back' : 'Remove — I already have this')+'">'+(excluded ? '+' : '×')+'</button>'+
    '</div>';
  });
  // Preserve any local items section
  var localSection = items.querySelector('.cart-local-header');
  var localHtml = '';
  if (localSection) {
    var el = localSection;
    while (el) { localHtml += el.outerHTML; el = el.nextElementSibling; }
  }
  items.innerHTML = cabHtml + localHtml;
  var activeSum = 0;
  cart.forEach(function(c) { if (!c._excluded) activeSum += c.price; });
  document.getElementById('cartTotalValue').textContent = '$' + activeSum.toFixed(2);
}

// Shopify cart integration: fetch variant IDs, then POST to /cart/add.js
function addAllToCart() {
  var cart = window._meadCart;
  if (!cart) return;
  var btn = document.getElementById('cartBtn');
  btn.textContent = 'Adding...';
  btn.disabled = true;
  var toAdd = cart.filter(function(c) { return c.handle && !c._excluded; });
  var promises = toAdd.map(function(c) {
    return fetch('/products/' + c.handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var variant = data.product.variants[0];
        return { id: variant.id, quantity: 1 };
      })
      .catch(function() { return null; });
  });
  Promise.all(promises).then(function(items) {
    items = items.filter(function(i) { return i !== null; });
    if (items.length === 0) {
      btn.textContent = 'No items to add';
      setTimeout(function() { btn.textContent = 'Add All to Cart →'; btn.disabled = false; }, 2000);
      return;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }).then(function(r) {
    if (r && r.ok) {
      btn.textContent = '✓ Added!';
      btn.style.background = 'var(--success)';
      // Refresh theme cart sidebar and open it (Craft a Brew theme pattern)
      fetch('?section_id=helper-cart')
        .then(function(r) { return r.text(); })
        .then(function(text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          // Update cart form content
          var newForm = parsed.getElementById('AjaxCartForm');
          var newSubtotal = parsed.getElementById('AjaxCartSubtotal');
          if (newForm && document.getElementById('AjaxCartForm')) {
            document.getElementById('AjaxCartForm').innerHTML = newForm.innerHTML;
            if (document.getElementById('AjaxCartForm').ajaxifyCartItems) {
              document.getElementById('AjaxCartForm').ajaxifyCartItems();
            }
          }
          if (newSubtotal && document.getElementById('AjaxCartSubtotal')) {
            document.getElementById('AjaxCartSubtotal').innerHTML = newSubtotal.innerHTML;
          }
          // Update header cart count and total
          var countEl = parsed.querySelector('[data-cart-count]');
          var totalEl = parsed.querySelector('[data-cart-total]');
          if (countEl) {
            document.querySelectorAll('[data-header-cart-count]').forEach(function(el) {
              el.textContent = countEl.textContent;
            });
          }
          if (totalEl) {
            document.querySelectorAll('[data-header-cart-total]').forEach(function(el) {
              el.textContent = totalEl.textContent;
            });
          }
          // Open cart sidebar drawer
          var sidebar = document.getElementById('site-cart-sidebar');
          if (sidebar && sidebar.show) {
            sidebar.show();
          }
        });
      setTimeout(function() {
        btn.textContent = 'Add All to Cart →';
        btn.style.background = '';
        btn.disabled = false;
      }, 3000);
    } else {
      btn.textContent = 'Error — try again';
      setTimeout(function() { btn.textContent = 'Add All to Cart →'; btn.disabled = false; }, 2000);
    }
  }).catch(function() {
    btn.textContent = 'Error — try again';
    setTimeout(function() { btn.textContent = 'Add All to Cart →'; btn.disabled = false; }, 2000);
  });
}

/* ============================================================
   TASTING NOTES + GLASS COLOR
   ============================================================ */

function generateTastingNotes() {
  var hasFruit = recipe.fruits.length > 0;
  var hasSpice = recipe.spices.length > 0;
  var sweetWord = SWEETNESS_LABELS[recipe.sweetness].toLowerCase();
  var article = /^[aeiou]/i.test(sweetWord) ? 'An' : 'A';
  var bodyWord = recipe.targetABV < 8 ? 'light-bodied' : recipe.targetABV < 13 ? 'medium-bodied' : 'full-bodied with noticeable warmth';

  var honeyNotes = [];
  recipe.honeys.forEach(function(h) {
    var honey = HONEYS.find(function(x) { return x.id === h.honeyId; });
    if (honey) honeyNotes.push(honey.flavor);
  });
  honeyNotes = honeyNotes.slice(0, 2).join(' and ');

  var desc = article + ' ' + sweetWord + ' ' + recipe.type + ' mead, ' + bodyWord + '. ';
  desc += 'The honey character brings ' + (honeyNotes || 'classic floral') + ' notes';
  if (hasFruit) {
    var fruitName = FRUITS.find(function(x) { return x.id === recipe.fruits[0].fruitId; });
    desc += ', layered with ' + (fruitName ? fruitName.name.toLowerCase() : 'fruit') + ' character';
  }
  if (hasSpice) desc += ' and warm spice complexity';
  if (recipe.yeast) desc += '. The ' + recipe.yeast.name + ' contributes ' + recipe.yeast.char.toLowerCase() + ' qualities';
  desc += '. Best after 3+ months of aging.';
  document.getElementById('tastingText').textContent = desc;
}

/* ============================================================
   GLASS COLOR SYSTEM (mask-image approach)
   The overlay div is masked to the exact shape of the glass PNG,
   so only the liquid + glass walls receive the tint — never the
   background rectangle. Multiply blend mode then mixes the tint
   color naturally with the underlying golden mead photo.
   ============================================================ */

// Per-ingredient color database (RGB values reflect the natural appearance
// of that ingredient when fermented into mead — calibrated from real photos).
// `strength` is a multiplier for how much pigment the ingredient contributes
// per pound (or per quart for juices, per oz for spices).
var INGREDIENT_COLORS = {
  // === RED BERRIES ===
  strawberry:    { r: 220, g: 70,  b: 100, strength: 1.0 },
  raspberry:     { r: 180, g: 30,  b: 70,  strength: 1.2 },
  blackberry:    { r: 70,  g: 25,  b: 55,  strength: 1.5 },
  cherry_sweet:  { r: 140, g: 30,  b: 50,  strength: 1.2 },
  cherry_tart:   { r: 200, g: 40,  b: 60,  strength: 1.1 },
  cranberry:     { r: 180, g: 30,  b: 50,  strength: 1.3 },
  pomegranate:   { r: 175, g: 40,  b: 70,  strength: 1.2 },
  currant_black: { r: 60,  g: 25,  b: 70,  strength: 1.5 },
  elderberry:    { r: 70,  g: 30,  b: 75,  strength: 1.5 },
  // === PURPLE / BLUE ===
  blueberry:     { r: 55,  g: 30,  b: 110, strength: 1.8 },
  grape_concord: { r: 85,  g: 40,  b: 105, strength: 1.4 },
  // === STONE FRUITS ===
  peach:         { r: 235, g: 175, b: 120, strength: 0.5 },
  apple:         { r: 210, g: 190, b: 110, strength: 0.3 },
  apricot:       { r: 235, g: 150, b: 80,  strength: 0.6 },
  plum:          { r: 130, g: 50,  b: 90,  strength: 1.0 },
  fig:           { r: 110, g: 60,  b: 80,  strength: 0.8 },
  // === TROPICAL ===
  mango:         { r: 250, g: 170, b: 50,  strength: 0.7 },
  pineapple:     { r: 240, g: 220, b: 110, strength: 0.4 },
  // === DRIED ===
  raisin:        { r: 110, g: 70,  b: 50,  strength: 0.8 },
  date:          { r: 100, g: 60,  b: 40,  strength: 0.9 },
  // === JUICES (per quart, lower strength than fresh fruit by weight) ===
  raw_cider:          { r: 200, g: 160, b: 70,  strength: 0.45 },
  apple_juice:        { r: 220, g: 195, b: 100, strength: 0.30 },
  grape_juice_white:  { r: 225, g: 220, b: 130, strength: 0.40 },
  grape_juice_purple: { r: 95,  g: 40,  b: 105, strength: 1.30 },
  cranberry_juice:    { r: 180, g: 40,  b: 60,  strength: 1.00 },
  orange_juice:       { r: 250, g: 160, b: 40,  strength: 0.70 },
  // === SPICES THAT AFFECT COLOR (per oz / per pc) ===
  // Hibiscus is intensely pigmented — 1 oz noticeably reddens 1 gal of mead.
  hibiscus:      { r: 170, g: 40,  b: 90,  strength: 2.5 },
  // Cacao nibs darken to chocolate-brown over time.
  cacao_nib:     { r: 90,  g: 50,  b: 30,  strength: 1.2 }
};

function updateGlassColor() {
  var img = document.getElementById('meadGlassImg');
  if (!img) return;
  var frame = img.closest('.glass-frame');
  if (!frame) return;

  // Wait until the glass image has loaded so we can use its src as the mask
  if (!img.src || !img.complete) {
    img.addEventListener('load', updateGlassColor, { once: true });
    return;
  }

  // === HONEY BASELINE: shift glass brightness/saturation based on honey density ===
  // 2.5 lb/gal = baseline (matches the photo). Less = paler straw, more = deeper gold.
  var totalHoneyLb = 0;
  recipe.honeys.forEach(function(h) { totalHoneyLb += h.amount; });
  var batchGal = parseFloat(document.getElementById('batchSize').value) || 1;
  var honeyPerGal = totalHoneyLb / batchGal;
  var honeyBright = 1.0 + (2.5 - honeyPerGal) * 0.06;
  honeyBright = Math.max(0.82, Math.min(1.15, honeyBright));
  var honeySat = 1.0 + (honeyPerGal - 2.5) * 0.05;
  honeySat = Math.max(0.85, Math.min(1.2, honeySat));
  img.style.filter = 'brightness(' + honeyBright.toFixed(2) + ') saturate(' + honeySat.toFixed(2) + ')';

  // === Create or find the masked color overlay ===
  // Position it using measured img coordinates (not CSS) to guarantee perfect
  // pixel alignment with the glass image, regardless of padding, flex layout,
  // or browser quirks. The overlay lives directly in .glass-frame and is
  // absolutely positioned to exactly match the <img>'s rendered box.

  // Clean up any stale wrapper from a prior approach that wrapped the <img>.
  var parent = img.parentElement;
  if (parent && parent.classList.contains('glass-inner')) {
    // Unwrap: move img back up to frame, remove wrapper
    parent.parentNode.insertBefore(img, parent);
    parent.parentNode.removeChild(parent);
  }

  frame.style.position = 'relative';
  var overlay = document.getElementById('glassColorOverlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'glassColorOverlay';
    frame.appendChild(overlay);
  } else if (overlay.parentElement !== frame) {
    frame.appendChild(overlay);
  }

  // Measure the img's actual rendered box relative to the frame
  var imgRect = img.getBoundingClientRect();
  var frameRect = frame.getBoundingClientRect();
  var relTop = imgRect.top - frameRect.top;
  var relLeft = imgRect.left - frameRect.left;

  // Prefer the dedicated silhouette mask (no shadow) if available
  var maskSrc = img.getAttribute('data-mask') || img.src;
  var maskUrl = "url('" + maskSrc + "')";
  overlay.style.cssText =
    'position:absolute;' +
    'top:' + relTop + 'px;' +
    'left:' + relLeft + 'px;' +
    'width:' + imgRect.width + 'px;' +
    'height:' + imgRect.height + 'px;' +
    'pointer-events:none;' +
    'mask-image:' + maskUrl + ';-webkit-mask-image:' + maskUrl + ';' +
    'mask-size:contain;-webkit-mask-size:contain;' +
    'mask-repeat:no-repeat;-webkit-mask-repeat:no-repeat;' +
    'mask-position:center;-webkit-mask-position:center;' +
    'mix-blend-mode:multiply;' +
    'transition:background-color 0.4s ease, opacity 0.4s ease;' +
    'opacity:' + (overlay.style.opacity || '0') + ';' +
    'background-color:' + (overlay.style.backgroundColor || 'transparent') + ';';

  // Keep overlay synced to img on window resize
  if (!window.__glassResizeHooked) {
    window.__glassResizeHooked = true;
    window.addEventListener('resize', function() {
      // Re-run to recompute img rect
      updateGlassColor();
    });
  }

  // === Accumulate weighted color from all fruits + color-affecting spices ===
  // Respect the same juice-volume cap that calcFruitGravityPoints applies, so the
  // visual matches the physics: if you specified more juice than fits, the color
  // reflects only what actually ends up in the batch.
  var totalJuiceGal = 0;
  recipe.fruits.forEach(function(f) {
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (fruit && fruit.isJuice) totalJuiceGal += f.amount / 4;
  });
  var juiceCap = Math.min(1, batchGal / Math.max(0.001, totalJuiceGal));

  var totalR = 0, totalG = 0, totalB = 0, totalWeight = 0;

  recipe.fruits.forEach(function(f) {
    var color = INGREDIENT_COLORS[f.fruitId];
    if (!color) return;
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    var effectiveAmount = (fruit && fruit.isJuice) ? f.amount * juiceCap : f.amount;
    var perGal = effectiveAmount / batchGal;     // lb/gal or qt/gal of what actually fits
    var weight = perGal * color.strength;        // pigment contribution
    totalR += color.r * weight;
    totalG += color.g * weight;
    totalB += color.b * weight;
    totalWeight += weight;
  });

  recipe.spices.forEach(function(s) {
    var color = INGREDIENT_COLORS[s.spiceId];
    if (!color) return;
    // Spice units vary — normalize to "per gallon" as best we can.
    // For oz/tsp/pc, treat the raw amount as the contribution unit.
    var perGal = s.amount / batchGal;
    var weight = perGal * color.strength;
    totalR += color.r * weight;
    totalG += color.g * weight;
    totalB += color.b * weight;
    totalWeight += weight;
  });

  if (totalWeight < 0.05) {
    // No meaningful color contribution — clear the overlay
    overlay.style.opacity = '0';
    overlay.style.backgroundColor = 'transparent';
    return;
  }

  // Weighted-average final color
  var r = Math.round(totalR / totalWeight);
  var g = Math.round(totalG / totalWeight);
  var b = Math.round(totalB / totalWeight);

  // Map total pigment weight to overlay opacity, with diminishing returns.
  // 0.5 → ~0.18, 1 → ~0.30, 2 → ~0.48, 3 → ~0.60, 4+ → caps near 0.72
  var opacity = 1 - Math.exp(-totalWeight * 0.35);
  opacity = Math.max(0.05, Math.min(0.72, opacity));

  overlay.style.backgroundColor = 'rgb(' + r + ',' + g + ',' + b + ')';
  overlay.style.opacity = opacity.toFixed(3);
}

/* ============================================================
   MAIN RECALCULATE
   ============================================================ */

function recalculate() {
  var honeyPoints = calcHoneyGravityPoints();
  var fruitPoints = calcFruitGravityPoints();
  var ogPoints = honeyPoints + fruitPoints;
  var og = 1 + (ogPoints / 1000);
  // Primary fermentation always runs to 1.000 (mead yeasts attenuate fully).
  // ABV is determined entirely by the primary, NOT by backsweetening.
  // The sweetness slider only changes what gets ADDED back after stabilization.
  var abv = ogPoints * 0.131;
  // Display FG = the user's backsweetening target (continuous slider value)
  var displayFG = recipe.backsweetFG || 1.000;

  // Sidebar stats
  document.getElementById('sOG').textContent = og.toFixed(3);
  document.getElementById('sFG').textContent = '1.000'; // Primary FG always 1.000
  document.getElementById('sFinalFG').textContent = displayFG.toFixed(3); // post-backsweetening
  document.getElementById('sABV').textContent = abv.toFixed(1) + '%';
  var sweetName = recipe.backsweetFG < 1.005 ? 'Dry' : recipe.backsweetFG < 1.015 ? 'Off-Dry' : recipe.backsweetFG < 1.025 ? 'Semi-Sweet' : 'Sweet';
  document.getElementById('sSweetness').textContent = sweetName;
  document.getElementById('sHoney').textContent = totalHoneyWeight().toFixed(1) + ' lb';
  var backRow = document.getElementById('sBackRow');
  if (recipe.backsweetFG > 1.002) {
    document.getElementById('sBackHoney').textContent = (calcBacksweetenHoney() * 16).toFixed(0) + ' oz';
    backRow.style.display = 'block';
  } else {
    backRow.style.display = 'none';
  }

  // Timeline stats
  document.getElementById('tlOG').textContent = og.toFixed(3);
  document.getElementById('tlFG').textContent = displayFG.toFixed(3);
  document.getElementById('tlABV').textContent = abv.toFixed(1) + '%';
  document.getElementById('tlDays').textContent = Math.round(estimateTotalDays());

  // Auto-adjust timeline scale to comfortably fit the estimated duration
  var estDays = estimateTotalDays();
  if (estDays > 90 && recipe.timelineDays !== 90) setTimelineScale(90);
  else if (estDays > 60 && recipe.timelineDays < 60) setTimelineScale(60);
  else if (estDays > 30 && recipe.timelineDays < 30) setTimelineScale(60);

  renderYeastRecommendations();
  renderYeastPacketInfo();
  renderTempControl();
  renderNutrientSchedule();
  renderTimelinePhases();
  renderTimelineChart();
  renderCart();
  generateTastingNotes();
  updateGlassColor();

  // === WARNINGS ===

  // Fruit volume warning: > 5 lbs fresh fruit per gallon may exceed fermenter capacity
  var totalFruitLbs = 0;
  recipe.fruits.forEach(function(f) {
    var fruit = FRUITS.find(function(x) { return x.id === f.fruitId; });
    if (fruit && !fruit.isJuice) totalFruitLbs += f.amount;
  });
  var fruitWarn = document.getElementById('fruitVolumeWarn');
  if (fruitWarn) fruitWarn.remove();
  if (totalFruitLbs > 5 * recipe.batchSize) {
    var warn = document.createElement('div');
    warn.id = 'fruitVolumeWarn';
    warn.style.cssText = 'background:#fdeaea;color:#c0392b;border-left:3px solid var(--danger);padding:8px 12px;border-radius:0 6px 6px 0;margin-top:10px;font-size:0.78rem;';
    warn.innerHTML = '\u26A0\uFE0F <strong>' + totalFruitLbs.toFixed(1) + ' lbs of fruit potentially exceeds ' + recipe.batchSize + '-gallon batch size.</strong> Ferment in a much larger container, like a bucket, or consider lowering the fruit amount to fit your fermentation vessel.';
    var fruitCard = document.getElementById('fruitBody');
    if (fruitCard) fruitCard.parentElement.appendChild(warn);
  }

  // High OG warning: OG > 1.130 may not finish fully dry
  var highOgWarn = document.getElementById('highOgWarn');
  if (highOgWarn) highOgWarn.remove();
  if (og > 1.130) {
    var warn2 = document.createElement('div');
    warn2.id = 'highOgWarn';
    warn2.style.cssText = 'background:var(--warning-light,#fef3e8);color:#b35b13;border-left:3px solid var(--warning,#e67e22);padding:8px 12px;border-radius:0 6px 6px 0;margin-top:8px;font-size:0.78rem;';
    warn2.innerHTML = '\u26A0\uFE0F <strong>OG ' + og.toFixed(3) + ' is at the upper end of yeast tolerance.</strong> This mead may not finish fully dry and could stall during fermentation. Consider reducing honey or choosing a high-tolerance yeast like EC-1118 (18% ABV).';
    var statsBody = document.querySelector('.stats-body');
    if (statsBody) statsBody.appendChild(warn2);
  }
}

/* ============================================================
   UI EVENTS
   ============================================================ */

function selectMeadType(t) {
  recipe.type = t;
  document.querySelectorAll('.mead-type-card').forEach(function(c) {
    c.classList.toggle('active', c.dataset.type === t);
  });
  // Show/hide conditional sections
  document.getElementById('fruitCard').classList.toggle('section-hidden', t !== 'melomel' && t !== 'cyser');
  document.getElementById('spiceCard').classList.toggle('section-hidden', t !== 'metheglin' && t !== 'melomel');
  // For cyser, auto-add apple juice if no fruit yet
  if (t === 'cyser' && recipe.fruits.length === 0) {
    recipe.fruits.push({ fruitId: 'apple_juice', amount: 1 });
    renderFruitRows();
  }
  recalculate();
}

function onBatchChange() {
  recipe.batchSize = parseFloat(document.getElementById('batchSize').value);
  // Auto-scale honey amounts proportionally to maintain target ABV
  var rec = recommendHoneyWeight();
  if (recipe.honeys.length === 1) {
    recipe.honeys[0].amount = parseFloat(rec.toFixed(2));
    renderHoneyRows();
  }
  recalculate();
}

function onAbvChange() {
  recipe.targetABV = parseFloat(document.getElementById('abvSlider').value);
  document.getElementById('abvValue').textContent = recipe.targetABV.toFixed(1) + '%';
  // Suggest honey amount
  var rec = recommendHoneyWeight();
  if (recipe.honeys.length === 1) {
    recipe.honeys[0].amount = parseFloat(rec.toFixed(2));
    renderHoneyRows();
  }
  recalculate();
}

function onSweetnessSlide() {
  var val = parseInt(document.getElementById('sweetnessSlider').value);
  var fg = val / 1000; // e.g. 1015 → 1.015
  recipe.backsweetFG = fg;
  // Determine closest named category
  var name;
  if (fg < 1.005) name = 'Dry';
  else if (fg < 1.015) name = 'Off-Dry';
  else if (fg < 1.025) name = 'Semi-Sweet';
  else name = 'Sweet';
  // Map to legacy sweetness index for backsweeten calculation compatibility
  recipe.sweetness = fg < 1.005 ? 0 : fg < 1.015 ? 1 : fg < 1.025 ? 2 : 3;
  document.getElementById('sweetnessDisplay').innerHTML =
    '<strong>' + name + '</strong><br><span style="font-size:0.72rem;color:var(--text-muted);">' + fg.toFixed(3) + ' FG</span>';
  recalculate();
}

function setSweetness(v) {
  // Used by presets — maps legacy index to the new FG slider
  var fgVals = [1.000, 1.010, 1.020, 1.030];
  recipe.sweetness = v;
  recipe.backsweetFG = fgVals[v];
  document.getElementById('sweetnessSlider').value = Math.round(fgVals[v] * 1000);
  onSweetnessSlide();
}

// Legacy — keep for presets that call it
function onSweetnessChange() {
  onSweetnessSlide();
}

function loadPreset(name) {
  if (name === 'traditional') {
    recipe.type = 'traditional';
    recipe.batchSize = 1;
    recipe.targetABV = 11;
    recipe.sweetness = 1; // Off-Dry
    recipe.honeys = [{ honeyId: 'cab_orange', amount: 2.5 }];
    recipe.fruits = []; recipe.spices = [];
    selectYeast('d47');
  } else if (name === 'cyser') {
    recipe.type = 'cyser';
    recipe.batchSize = 1;
    recipe.targetABV = 9;
    recipe.sweetness = 1;
    recipe.honeys = [{ honeyId: 'cab_wildflower', amount: 1.5 }];
    recipe.fruits = [{ fruitId: 'apple_juice', amount: 3 }];
    recipe.spices = [];
    selectYeast('71b1122');
  } else if (name === 'sack') {
    recipe.type = 'traditional';
    recipe.batchSize = 1;
    recipe.targetABV = 16;
    recipe.sweetness = 3; // Sweet
    recipe.honeys = [{ honeyId: 'cab_orange', amount: 4 }];
    recipe.fruits = []; recipe.spices = [];
    selectYeast('ec1118');
  }
  // Sync UI controls
  document.getElementById('batchSize').value = recipe.batchSize;
  document.getElementById('abvSlider').value = recipe.targetABV;
  document.getElementById('abvValue').textContent = recipe.targetABV.toFixed(1) + '%';
  setSweetness(recipe.sweetness);
  selectMeadType(recipe.type);
  renderHoneyRows();
  renderFruitRows();
  renderSpiceRows();
  recalculate();
}

/* ============================================================
   INIT
   ============================================================ */

function init() {
  renderHoneyRows();
  renderFruitRows();
  renderSpiceRows();
  renderYeastRecommendations();
  selectYeast('d47'); // Default
  renderNutrientSchedule();
  renderTimelinePhases();
  setTimeout(renderTimelineChart, 50);
  recalculate();
  window.addEventListener('resize', function() { setTimeout(renderTimelineChart, 100); });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();